import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 30, className = '' }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const MaskLines = ({ lines, className = '', delay = 0 }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span className="mask-line" key={i}>
                <motion.span
                    initial={{ y: '112%' }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.9, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const SectionHeading = ({ eyebrow, title, dark = false, id }) => (
    <Reveal>
        <p
            className={`font-ink text-[11px] uppercase tracking-[0.3em] ${dark ? 'text-pastelcream/60' : 'text-crimson'}`}
            data-testid={id ? `${id}-eyebrow` : 'section-eyebrow'}
        >
            {eyebrow}
        </p>
        <h2
            className={`font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.08] ${dark ? 'text-pastelcream' : 'text-ink'}`}
            data-testid={id ? `${id}-title` : 'section-title'}
        >
            {title}
        </h2>
    </Reveal>
);
